import { ChildrenModelBase } from "./children-base.model";

export class TableFilter extends ChildrenModelBase {
  public tableFilterGroupId: number;
  public columnId: number;
  public comparerId: number;
  public value: string;
  public combinerId: number;
}
